import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

export const SelectWrapper = styled.div`
  align-self: flex-start;
  align-items: center;
  display: flex;
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;

  & > :not(:first-of-type) {
    margin-left: ${spacing.xSmall};
  }
`;

export const SelectContainer = styled.div`
  flex-grow: 1;
  max-width: 100%;
`;
